import {createEvent} from './event-factory';
export {GATracker} from './trackers';

export const createTracker = tracker => store => next => action => {
    const prevState = store.getState();
    next(action);
    const event = createEvent(action, store.getState(), prevState);
    if (event) tracker.track(event);
};



// WEBPACK FOOTER //
// ./scripts/tracking/index.js